import api from "../../api";
import {AxiosResponse} from "axios";
import {BankModuleServiceInterface} from "../../types";
import {BaseAddResponse, BaseEditResponse} from "../../types/response";
import {BankAddRequest, BankEditRequest, BankListRequest, BankPrepareEditFormRequest, BankViewRequest} from "../../types/modules/bank/request";
import {BankListResponse, BankPrepareAddFormResponse, BankPrepareEditFormResponse, BankViewResponse} from "../../types/modules/bank/response";

export class BankService implements BankModuleServiceInterface {
    public list(request: BankListRequest): Promise<AxiosResponse<BankListResponse>> {
        return api.get('/company_administration/bank/', { params: request });
    }
    public edit(request: BankEditRequest): Promise<AxiosResponse<BaseEditResponse>> {
        return api.put(`/company_administration/bank/${request.id}/edit`, request);
    }
    public view(request: BankViewRequest): Promise<AxiosResponse<BankViewResponse>> {
        return api.get(`/company_administration/bank/${request.id}/view`);
    }
    public add(request: BankAddRequest): Promise<AxiosResponse<BaseAddResponse>> {
        return api.post(`/company_administration/bank/add`, request);
    }
    public prepareEditForm(request: BankPrepareEditFormRequest): Promise<AxiosResponse<BankPrepareEditFormResponse>> {
        return api.get(`/company_administration/bank/${request.id}/prepare_edit`);
    }
    public prepareAddForm(): Promise<AxiosResponse<BankPrepareAddFormResponse>> {
        return api.get(`/company_administration/bank/prepare_add`);
    }
}